import withLazyImport from '../../../common/hoc/with-lazy-import';

export default withLazyImport(() => import(/* webpackChunkName: "rich-content-editor" */ './rich-content-editor'));
